<template>
  <b-modal :id="id" v-model="showModal" size="xl" @hidden="cancelar" @close="cancelar" button-size="md" hide-footer
    :title="prefix + title">
    <HierarquiaUnidadeAdministrativa @rowSelect="rowSelect" :idFinderLocal="id + '-list'" :title="''" :prefix="prefix + title " :idPaiProp="idPai">
    </HierarquiaUnidadeAdministrativa>
  </b-modal>
</template>
<script>
export default {
  components: {
    HierarquiaUnidadeAdministrativa: ()=>import("@/modules/cadastros/hierarquia-unidade-administrativa/HierarquiaUnidadeAdministrativaList.vue"),
  },
  name: "ModalPageHierarquiaUnidadeAdministrativa",
  props: {
    
    id: {
      type: String,
      default: "",
    },
    prefix: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    idPai:
      { type: Number, default: null },
  },

  data() {
    return {
      showModal: true,
    }
  },

  beforeMount() {
  },

  methods: {
    cancelar() {
      this.$emit("close")
    },
    rowSelect(item){
        this.$emit("rowSelect", item);
    }
  },
}
</script>
